// Central nav source of truth — sidebar + route → icon mapping.
// Ordered exactly per codegen.md §1.

import {
  LayoutDashboard,
  Bot,
  Inbox,
  Radio,
  Wrench,
  Sparkles,
  GitBranch,
  BookOpen,
  BarChart3,
  Shield,
  Settings,
  type LucideIcon,
} from 'lucide-react';

export interface NavItem {
  id: string;
  label: string;
  path: string;
  icon: LucideIcon;
}

export const NAV_ITEMS: NavItem[] = [
  { id: 'dashboard', label: 'Dashboard', path: '/dashboard', icon: LayoutDashboard },
  { id: 'agents', label: 'Agents', path: '/agents', icon: Bot },
  { id: 'inbox', label: 'Inbox', path: '/inbox', icon: Inbox },
  { id: 'channels', label: 'Channels', path: '/channels', icon: Radio },
  { id: 'mcps', label: 'MCP Tools', path: '/mcp-tools', icon: Wrench },
  { id: 'skills', label: 'Skills', path: '/skills', icon: Sparkles },
  { id: 'workflows', label: 'Workflows', path: '/workflows', icon: GitBranch },
  { id: 'knowledge', label: 'Knowledge', path: '/knowledge', icon: BookOpen },
  { id: 'analytics', label: 'Analytics', path: '/analytics', icon: BarChart3 },
  { id: 'governance', label: 'Governance', path: '/governance', icon: Shield },
  { id: 'settings', label: 'Settings', path: '/settings', icon: Settings },
];
